import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Tab } from "@chakra-ui/react";

const CustomTab = ({
  children,
  w = "40%",
}: {
  children: string | string[];
  w?: string;
}) => {
  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  };

  return (
    <Tab
      w={w}
      color="#7E8B9A"
      whiteSpace="nowrap"
      onClick={() => triggerHapticFeedback(ImpactStyle.Medium)}
      _selected={{
        color: "#171C22",
        borderColor: "#171C22",
        borderBottomWidth: "2px",
        marginBottom: "-0.5px"
      }}
    >
      {children}
    </Tab>
  );
};

export default CustomTab;
